import { DELETE_PROGRAM_TYPE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_PROGRAM_TYPE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PROGRAM_TYPE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_PROGRAM_TYPE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
